import { QueryState, QueryStateSentrynel } from '../core/models/query.model';
import { SignalStoreConfig } from '../shared/functions/store.functions';

export const queryStateConfig: SignalStoreConfig<QueryState> = {
  initState: {
    list: [],
    pageable: {
      page: 0,
      size: 20,
      totalElements: 0,
      totalPages: 0,
    },
    sort: undefined,
    filters: {},
    isLoading: false
  }
}

export const queryStateConfigSentrynel: SignalStoreConfig<QueryStateSentrynel> = {
  initState: {
    list: [],
    meta: {
      totalItems:0,
      totalPages:0,
      currentPage:0, 
      itemsPerPage:20,
    },
    sort: undefined,
    filters: {},
    isLoading: false
  }
}
